/**
 * Lit helpers shared by the Ligonier web components.
 */

import type { ComplexAttributeConverter } from 'lit'

/**
 * Boolean converter that recognises the string "false" as falsy, so consumers
 * can write `show-callout="false"` in HTML to disable a feature that defaults
 * to `true`. (Lit's default Boolean converter treats attribute *presence* as
 * true, so `="false"` would otherwise still read as true.)
 *
 * Attribute REMOVAL returns `null` rather than a boolean so the property falls
 * back to its declared default — pair every use with `useDefault: true` in the
 * property options. (Without the null, removal would force `true`, silently
 * inverting properties that default to `false`.)
 */
export const booleanStringConverter: ComplexAttributeConverter<boolean | null> = {
  fromAttribute: (value: string | null) => (value === null ? null : value !== 'false'),
  toAttribute: (value: boolean | null) => String(value),
}
